import { render, staticRenderFns } from "./EmbroideryReport.vue?vue&type=template&id=0a0201ba"
import script from "./EmbroideryReport.vue?vue&type=script&lang=js"
export * from "./EmbroideryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports